import Big from 'big.js'
import { Measure, Unit } from '../types'

export const convertValueFromUnitToUnit = (measure: Measure, value: Big, fromUnit: Unit, toUnit: Unit): Big => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!measure.units[fromUnit.codeName]) throw new Error(`Unsupported unit: ${fromUnit.displayName}`)
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!measure.units[toUnit.codeName]) throw new Error(`Unsupported unit: ${toUnit.displayName}`)

  const baseUnitValue = measure.units[fromUnit.codeName].toBaseUnit(value)
  return measure.units[toUnit.codeName].fromBaseUnit(baseUnitValue)
}
